import { useState } from 'react';
import { t } from '../../i18n/i18n';
import Cross from '../../assets/common/Cross';

const ExperimentalFeatureBanner = ({
  title = t('EXPERIMENTAL_FEATURE_BANNER_TITLE'),
  message = t('EXPERIMENTAL_FEATURE_BANNER_MESSAGE'),
  dismissible = true,
  variant = 'info', // 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'
  icon = 'bi bi-info-circle-fill',
}) => {
  const [showBanner, setShowBanner] = useState(true);

  if (!showBanner) return null;

  return (
    <div
      className={`alert alert-${variant} ${
        dismissible ? 'alert-dismissible' : ''
      } fade show d-flex align-items-center justify-content-between mb-3`}
      role="alert"
    >
      <div className="d-flex align-items-center">
        {icon && <i className={`${icon} me-2`} />}
        <span>
          {title && <strong>{title}: </strong>}
          {message}
        </span>
      </div>
      {dismissible && (
        <button
          type="button"
          className="btn btn-link p-0 border-0 bg-transparent"
          aria-label="Close"
          onClick={() => setShowBanner(false)}
        >
          <Cross />
        </button>
      )}
    </div>
  );
};

export default ExperimentalFeatureBanner;
